import Elogios   from "@/components/Pages/SAC/Elogios.vue"
import Duvidas   from "@/components/Pages/SAC/Duvidas.vue"
import Reclamacoes    from "@/components/Pages/SAC/Reclamacoes.vue"

export default [
	{
		name: "Elogios",
		path: ":get",
		component: Elogios,
		props: true
	},

	{
		name: "Duvidas",
		path: ":get",
		component: Duvidas,
		props: true
	},

	{
		name: "Reclamacoes",
		path: ":get",
		component: Reclamacoes,
		props: true
	},

	
]